export default __webpack_public_path__ + "static/media/profiili-darkblue.c3e3a421.svg";